export { AtnDsWidgetComponent as Component } from './widget.component'
